<template>
  <div v-if="breadcrumb" class="breadcrumb container mx-width">
    <ol class="breadcrumb-list" vocab="http://schema.org/" typeof="BreadcrumbList">
      <li v-for="(entry, index) in breadcrumb" :key="index + 1" class="breadcrumb-item" property="itemListElement" typeof="ListItem">
        <a property="item" typeof="WebPage" :href="entry.url">
          <span property="name">{{ entry.title }}</span>
        </a>
        <meta property="position" :content="index + 1" />
        <i v-if="index < breadcrumb.length - 1" class="af af-chevron-right breadcrumb-arrow" />
      </li>
    </ol>
  </div>
</template>
<script>
// Using this breadcrumb for the product page as the composition based breadcrumb causes a layout shift. Can swap back to using
// Breadcrumb.vue when we solve the layout shift issues.

export default {
  name: 'Breadcrumb',
  props: ['breadcrumb']
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';
@import '~@article/pixel/dist/style/mixins';

.breadcrumb {
  width: 100%;
  margin: auto;
  color: var(--grey-medium);
  &:after {
    position: absolute;
    content: '';
    background: linear-gradient(0deg, rgba(white, 0), white);
    opacity: 1;
    top: 0;
    right: 20px;
    width: 30px;
    height: 100%;
  }

  @media (max-width: $mobile-breakpoint - 1) {
    &.sticky {
      height: 50px;
      background: var(--white);
      display: flex;
      align-items: center;
      position: sticky;
      top: 0;
      z-index: 10;
    }
  }
}

.breadcrumb-list {
  padding: 0;
  margin: 0;

  @media (max-width: $tablet-breakpoint - 1) {
    overflow-x: scroll;
  }

  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  :last-child a {
    pointer-events: none;
  }
}

@-moz-document url-prefix() {
  .breadcrumb-list {
    scrollbar-width: none;
  }
}

.breadcrumb-item {
  font-size: var(--font-size-12);
  display: table-cell;
  list-style: none;
  white-space: nowrap;
  padding-right: var(--space-2);

  a {
    margin-right: var(--space-1);
  }

  i {
    font-size: 8px;
  }
}
</style>
